import React from 'react';
import PropTypes from 'prop-types';
import styles from './AggregatesPopup.module.css';
import clsx from 'clsx';
import moment from 'moment';
import { AGGREGATES, AGGREGATE_STATUS } from '../../../../constants';
import { sortByName } from '../../../../utils/tableUtils';

const AggregatesPopup = ({ materials, vc }) => {
  const comments = materials
    .flatMap((materialGroup) =>
      materialGroup.materials.map((material) => ({
        ...materialGroup,
        ...material,
      }))
    )
    .filter((material) => material.aggregateComment);
  materials.sort(sortByName);

  const colorStyleByStatus = new Map([
    [AGGREGATE_STATUS.BOOKED, styles.green],
    [AGGREGATE_STATUS.READY_FOR_PICKUP, styles.green],
    [AGGREGATE_STATUS.LINE_OUT, styles.red],
  ]);

  const getColorStyle = (status) => colorStyleByStatus.get(status);

  const getAvailabilityString = (status) =>
    status === AGGREGATE_STATUS.READY_FOR_PICKUP ||
    status === AGGREGATE_STATUS.BOOKED
      ? 'Available'
      : 'Unavailable';

  return (
    <div className={styles.AggregateBox}>
      <div className={styles.inner}>
        <div className={styles.vcNumberDisplay}>
          <div style={{ width: '40%', float: 'left' }}>VC</div>
          <div style={{ width: '60%', float: 'left', textAlign: 'right' }}>
            {vc}
          </div>
        </div>
        <span className={styles.title}>Aggregate Status</span>
        {materials.map(({ name, materials }) => (
          <div className={clsx(styles.row)} key={name}>
            <strong>{name}</strong>{' '}
            <div>
              {materials.map(({ material, aggregateStatus }) => (
                <div
                  style={{ textAlign: 'end' }}
                  className={clsx(getColorStyle(aggregateStatus))}
                >
                  {name === AGGREGATES.MATERIAL
                    ? getAvailabilityString(aggregateStatus)
                    : material}
                </div>
              ))}
            </div>
          </div>
        ))}
        {comments.map(({ name, comment, modifiedAt }) => (
          <div className={styles.grTxt} key={modifiedAt}>
            <strong>Aggregate: {name}</strong>
            <br />
            <strong>Comment: {comment}</strong>
            <br />
            {moment(modifiedAt).format('DD MMM YYYY hh:mm A')}
          </div>
        ))}
      </div>
    </div>
  );
};

const materialPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  material: PropTypes.string,
  status: PropTypes.string.isRequired,
  comment: PropTypes.string,
  modifiedAt: PropTypes.string,
  aggregateStatus: PropTypes.string.isRequired,
  aggregateModifiedAt: PropTypes.string,
  aggregateComment: PropTypes.string,
});

AggregatesPopup.propTypes = {
  materials: PropTypes.arrayOf(materialPropType),
  vc: PropTypes.string.isRequired,
};

export default AggregatesPopup;
